import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateLegalGuardianAttestationMutation as useChUpdateLegalGuardianAttestationMutationType } from "@/modules/patients/detail/legal-guardian-attestation/ch/services/__generated__/useChUpdateLegalGuardianAttestationMutation.graphql"

const mutation = graphql`
  mutation useChUpdateLegalGuardianAttestationMutation($input: Ch_updateAttestationGuardianInput!) {
    ch_updateAttestationGuardian(input: $input) {
      ch_AttestationGuardian {
        id
        ...chLegalGuardianAttestationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateLegalGuardianAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateLegalGuardianAttestationMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateLegalGuardianAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateLegalGuardianAttestationMutation }
